import { Dispatch, SetStateAction } from "react";
import Image from "../../../components/Image/Image.component";
import Overlay from "../../../components/Overlay/Overlay.component";

export default function PreviewImage({
  src,
  setSrc,
}: {
  src: string;
  setSrc: Dispatch<SetStateAction<string>>;
}) {
  return (
    <Overlay
      onClick={() => {
        if (src) {
          setSrc("");
        }
      }}
      className="flex items-center justify-center"
    >
      <Image
        className="w-1/2 aspect-square"
        src={src}
        width={600}
        height={600}
        alt="Chat Preview Image"
      />
    </Overlay>
  );
}
